import React from 'react';
import Header from './Header';

class BookingSuccess extends React.Component {

    getMainLocation() {
        let boutique = null;

        if (!this.props.boutiques) {
            return boutique;
        }
        this.props.boutiques.forEach(function(item) {
            if (item.mainLocation) {
                boutique = item;
            }
        })

        return boutique;
    }

    getActiveLocation() {
        let boutique = null;

        if (!this.props.boutiques) {
            return boutique;
        }

        this.props.boutiques.forEach(function(item) {
            if (item.checked) {
                boutique = item;
            }
        })

        return boutique;
    }

    shouldComponentUpdate() {
        return false;
    }

    renderBoutiqueBlock(boutique) {
        return (
            <div className="booking-form__success-inner bg-white md:w-3/4 mx-auto flex">
                <div className="booking-form__success-location md:w-3/4 mx-auto flex-wrap md:flex-no-wrap flex items-center justify-center">
                    <img className="booking-form__success-location-image" src={boutique.image} />
                    <div className="booking-form__success-location-text">
                        <h3 className="booking-form__success-location-address">{boutique.name}</h3>
                        <div className="booking-form__success-location-name" dangerouslySetInnerHTML={{__html: boutique.address}}></div>
                    </div>
                </div>
            </div>
        )
    }

    getInstructionsList() {
        let serviceInstructionsRendered = [];
        return this.props.services.map((service, index) => {
            if (service.instructions && !serviceInstructionsRendered.includes(service.wpid)) {
                serviceInstructionsRendered.push(service.wpid);
                return <p key={index} className="booking-form__instructions">{service.instructions}</p>
            } else {
                return null;
            }
        });
    }

    shouldRenderInstructions() {
        let shouldRender = false;
        this.props.services.forEach(function(item) {
            if (item.instructions) {
                shouldRender = true;
            }
        });

        return shouldRender;
    }

    renderInstructionsBlock(instructions) {
        return (
            <div className="booking-form__success-inner booking-form__instructions-block bg-white md:w-3/4 mx-auto">
                <h4 className="booking-form__instructions-title">{trans.before_your_appointment}</h4>
                { instructions }
            </div>
        )
    }

    render() {
        let boutique = this.getActiveLocation();
        
        if (boutique && boutique.empty) {
            boutique = this.getMainLocation();
        }

        const instructions = this.getInstructionsList();

        const successText = trans.booking_success_text
            .replace('{{client_email}}', '<b>' + this.props.email + '</b>')
            .replace('{{client_phone}}', '<b>' + this.props.phone + '</b>'); 

        return (
            <div className="booking-form__success">
                <div className="booking-form__success-inner bg-white md:w-3/4 mx-auto">
                    <i className="booking-form__success-icon fas fa-check-circle"></i>
                    <h3 className="booking-form__success-title w-full text-center">
                        {trans.booking_success_title}
                    </h3>

                    <div className="booking-form__success-text w-full text-center" 
                        dangerouslySetInnerHTML={{__html: successText}}>
                    </div>

                    <div className="booking-form__success-text w-full text-center">
                        { trans.booking_success_text2 }
                    </div>
                </div>
                { boutique  && this.renderBoutiqueBlock(boutique) }
                { this.shouldRenderInstructions() && this.renderInstructionsBlock(instructions) }
            </div>
        )
    }
}


export default BookingSuccess;


// WEBPACK FOOTER //
// ./scripts/components/BookingSuccess.jsx